import { ICON_COMPONENTS, type IconMetaphor } from './constants';

export const getIcon = (metaphor: IconMetaphor) => ICON_COMPONENTS[metaphor];
